const pageCategory = window.location.pathname.replace(/\//g, "");

export const common = {
  Category :'Enhanced Ecommerce', 
  Value: 0,
};

export const productClicked = {
  common: {
    Label: 'Product Click',
    noninteraction: false,
    event: 'eeEvent',
    Action: 'Browse'
  },
  typeKey: 'click',
  actionField:{
    list : pageCategory
  },
  valueType: {}
};

export const productAdded = {
  common: {
    Label: 'Product Add to Cart',
    noninteraction: false,
    event: 'eeCart',
    Action: 'Browse'
  },
  typeKey: 'add',
  valueType: {}
};

export const productViewed = {
  common: {
    Label: 'Product Detail Viewed',
    noninteraction: true,
    event: 'eeEvent',
    Action: 'Browse',
  },
  typeKey: 'detail',
  actionField:{
    action: "detail",
  },
  valueType: {}
};

export const productListViewed = {
  common: {
    Label: 'Product Impressions',
    noninteraction: true,
    event: 'eeEvent',
    Action: 'Browse',
  },
  typeKey: 'impressions',
  valueType: []
};

export const productRemoved = {
  common: {
    Label: 'Product Remove from Cart',
    noninteraction: false,
    event: 'eeCart',
    Action: 'Browse'
  },
  typeKey: 'remove',
  valueType: {}
};

export const cartViewed = {
  common: {
    Label: 'Sepet',
    noninteraction: true,
    event: 'eeCheckout',
    Action: 'Checkout'
  },
  typeKey: 'checkout',
  actionField:{
    action: 'checkout',
    step: 1
  },
  valueType: {}
};

export const checkoutStep = {
  common: {
    Label: 'Login',
    noninteraction: true,
    event: 'eeCheckout',
    Action: 'Checkout'
  },
  typeKey: 'checkout',
  actionField:{
    action: 'checkout',
    step: 2
  },
  valueType: {}
};

export const checkoutStepViewed = {
  common: {
    Label: 'Adres',
    noninteraction: true,
    event: 'eeCheckout',
    Action: 'Checkout'
  },
  typeKey: 'checkout',
  actionField:{
    action: 'checkout',
    step: 3
  },
  valueType: {}
};

export const checkoutStepViewedPayment = {
  common: {
    Label: 'Ödeme',
    noninteraction: true,
    event: 'eeCheckout',
    Action: 'Checkout'
  },
  typeKey: 'checkout',
  actionField:{
    action: 'checkout',
    step: 4
  },
  valueType: {}
};

export const orderCompleted = {
  common: {
    Label: 'Purchase',
    noninteraction: true,
    event: 'eepurchase',
    Action: 'Checkout'
  },
  typeKey: 'purchase',
  valueType: {}
};

export const cartDetailEvent = {
  common: {
    Label: 'Product Attributes',
    noninteraction: true,
    event: 'cartDetailEvent',
    Action: 'Basket Product'
  },
  typeKey: 'cartProducts',
  valueType: []
};

export const promotionViewed = {
  common: {
    Label: 'Promotion Impressions',
    noninteraction: true,
    event: 'eeEvent',
    Action: 'Browse'
  },
  typeKey: 'promoView',
  valueType: {}
};

export const promotionClick = {
  common: {
    Label: 'Promotion Click',
    noninteraction: true,
    event: 'eeEvent',
    Action: 'Browse'
  },
  typeKey: 'promoClick',
  valueType: {}
};

export const loginAction = {
  common: {
    'Category':'Member',
    'Action':'Login',
    'Label': new Date(),
    'event':'gaEvent'
  }
};
export const signUpAction = {
  common: {
    'Category':'Member',
    'Action':'Sign Up',
    'Label': new Date(),
    'event':'gaEvent'
  }
};

